import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { Interceptor } from '../../token/inteceptor';
// import { SeguPeriodoService } from '../../../../shared/services/seguridad/seguPeriodo/seguPeriodo.service';
// import { PerfilService } from '../../../../shared/services/seguridad/perfil/perfil.service';
// import { AplicacionService } from '../../../../shared/services/seguridad/aplicacion/aplicacion.service';
// import { OpcionesUsuarioService } from '../../../../shared/services/seguridad/opciones-usuario/opciones-usuario.service';
// import { MenuService } from '../../../../shared/services/seguridad/menu/menu.service';
// import { RolService } from '../../../../shared/services/seguridad/rol/rol.service';
// import { UsuarioService } from '../../../../shared/services/seguridad/usuario/usuario.service';
import { TipoUsuarioService } from '../../../../shared/services/seguridad/tipo-usuario/tipo-usuario.service';
import { Interceptor } from '../../token/interceptor';
import { UsuarioService } from '../usuario/usuario.service';
import { MenuService } from '../menu/menu.service';
import { PerfilService } from '../perfil/perfil.service';
import { OpcionesUsuarioService } from '../opciones-usuario/opciones-usuario.service';
import { AplicacionService } from '../aplicacion/aplicacion.service';
import { RolService } from '../rol/rol.service';
import { SeguPeriodoService } from '../seguPeriodo/seguPeriodo.service';
import { TipoUsuarioPerfilService } from '../tipoUsuarioPerfil/tipoUsuarioPerfil.service';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedSeguridadModule {
  static forRoot(): ModuleWithProviders <SharedSeguridadModule>{
    return {
      ngModule: SharedSeguridadModule,
      providers: [
        TipoUsuarioService,UsuarioService,
          MenuService, PerfilService,
         UsuarioService, OpcionesUsuarioService, RolService,
        AplicacionService,SeguPeriodoService,TipoUsuarioPerfilService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }
    ]
    };
  }
}
